import { InjectionToken } from '@angular/core';
export var InternalDynamicParameters;
(function (InternalDynamicParameters) {
    InternalDynamicParameters["click_id"] = "click_id";
    InternalDynamicParameters["external_click_id"] = "external_click_id";
    InternalDynamicParameters["browser"] = "browser";
    InternalDynamicParameters["ip"] = "ip";
    InternalDynamicParameters["traffic_source"] = "traffic_source";
    InternalDynamicParameters["country_iso_code"] = "country_iso_code";
    InternalDynamicParameters["language_iso_code"] = "language_iso_code";
    InternalDynamicParameters["commission_type"] = "commission_type";
    InternalDynamicParameters["rule_price"] = "rule_price";
    InternalDynamicParameters["p1"] = "p1";
    InternalDynamicParameters["p2"] = "p2";
    InternalDynamicParameters["p3"] = "p3";
    InternalDynamicParameters["p4"] = "p4";
    InternalDynamicParameters["p5"] = "p5";
    InternalDynamicParameters["p6"] = "p6";
    InternalDynamicParameters["p7"] = "p7";
    InternalDynamicParameters["p8"] = "p8";
    InternalDynamicParameters["p9"] = "p9";
    InternalDynamicParameters["p10"] = "p10";
})(InternalDynamicParameters || (InternalDynamicParameters = {}));
export const IDynamicParametersConfigToken = 'IDynamicParametersConfigToken';
export const InternalDynamicParametersConfig = new InjectionToken(IDynamicParametersConfigToken);
